import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import * as Icons from "lucide-react";
import { images } from "../mock";

export const BulkRemarketing = () => {
  const services = [
    {
      title: "Große Laptop-Bestände",
      description: "Ankauf von Laptop-Beständen ab 20 Geräten bis zu mehreren hundert Einheiten",
      icon: "Package",
      features: [
        "Flexible Mengenabnahme",
        "Individuelle Preisgestaltung",
        "Komplettabwicklung",
      ],
    },
    {
      title: "IT-Rollouts",
      description: "Professionelle Abnahme bei Hardware-Rollouts und IT-Modernisierungsprojekten",
      icon: "RefreshCw",
      features: [
        "Projektbegleitung",
        "Termingerechte Abholung",
        "Dokumentation",
      ],
    },
    {
      title: "Hardware-Refresh-Projekte",
      description: "Unterstützung bei kompletten Hardware-Refresh-Projekten mit Altgeräte-Ankauf",
      icon: "Sparkles",
      features: [
        "Planungssicherheit",
        "Kostenoptimierung",
        "Nachhaltige Verwertung",
      ],
    },
    {
      title: "Leasing-Rückläufer",
      description: "Ankauf von Leasing-Rückläufern in größeren Mengen für Leasinggesellschaften",
      icon: "FileText",
      features: [
        "Komplettabnahme",
        "Faire Bewertung",
        "Schnelle Abwicklung",
      ],
    },
  ];

  const remarketing = [
    {
      title: "IT-Remarketing Expertise",
      description: "Über 10 Jahre Erfahrung im professionellen IT-Remarketing",
      icon: "Award",
    },
    {
      title: "Nachhaltige Verwertung",
      description: "Umweltgerechte Aufbereitung und Wiedervermarktung der Geräte",
      icon: "Recycle",
    },
    {
      title: "Maximaler Restwert",
      description: "Bestmögliche Verwertung für maximalen Rückfluss",
      icon: "TrendingUp",
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-blue-50 py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Großmengen & IT-Remarketing
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Professionelle Lösungen für große Laptop-Bestände, IT-Rollouts und 
              Hardware-Refresh-Projekte. Wir bieten maßgeschneiderte Ankaufskonzepte 
              für Ihre spezifischen Anforderungen.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Unsere Großmengen-Services
            </h2>
            <p className="text-xl text-gray-600">
              Spezialisiert auf professionelle B2B-Projekte
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {services.map((service, index) => {
              const Icon = Icons[service.icon];
              return (
                <Card key={index} className="border-blue-100 hover:border-blue-300 hover:shadow-lg transition-all duration-300">
                  <CardContent className="p-8">
                    <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                      <Icon className="text-blue-600" size={28} />
                    </div>
                    <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-lg mb-4">
                      {service.description}
                    </p>
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center text-gray-700">
                          <Icons.CheckCircle2 className="text-blue-600 mr-2 flex-shrink-0" size={18} />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <img
              src={images.businessMeeting}
              alt="Business IT Meeting"
              className="w-full h-96 object-cover rounded-2xl shadow-lg"
            />
          </div>
        </div>
      </section>

      {/* Remarketing Expertise Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              IT-Remarketing Expertise
            </h2>
            <p className="text-xl text-gray-600">
              Professionelle Verwertung Ihrer IT-Hardware
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {remarketing.map((item, index) => {
              const Icon = Icons[item.icon];
              return (
                <Card key={index} className="border-blue-100 hover:border-blue-300 hover:shadow-md transition-all duration-300">
                  <CardContent className="p-8 text-center">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon className="text-blue-600" size={32} />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {item.title}
                    </h3>
                    <p className="text-gray-600">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-blue-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-12 text-center">
              Vorteile bei Großmengen
            </h2>
            <div className="space-y-6">
              {[
                {
                  title: "Individuelle Konditionen",
                  description: "Maßgeschneiderte Ankaufspreise abhängig von Menge und Zustand",
                },
                {
                  title: "Projektmanagement",
                  description: "Dedizierter Ansprechpartner für Ihr Projekt",
                },
                {
                  title: "Flexible Logistik",
                  description: "Deutschlandweite Abholung nach Ihrem Zeitplan",
                },
                {
                  title: "Komplettservice",
                  description: "Von der Bewertung bis zur Datenlöschung – alles aus einer Hand",
                },
              ].map((benefit, index) => (
                <Card key={index} className="border-blue-200 hover:shadow-md transition-all duration-300">
                  <CardContent className="p-6 flex items-start space-x-4">
                    <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                      <Icons.Check className="text-white" size={20} />
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-2">
                        {benefit.title}
                      </h3>
                      <p className="text-gray-600">
                        {benefit.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-700 text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6">
              Großprojekt geplant?
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Kontaktieren Sie uns für eine individuelle Beratung
            </p>
            <Link to="/request-quote">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-gray-100 font-medium shadow-lg">
                Jetzt Projektanfrage stellen
                <Icons.ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
